import { useEffect, useState } from 'react';
import { Modal, Select, Button, notification, Spin } from 'antd';
import { apiGroupsList } from '../../../../api/groups';
import { apiUpdateAccessAccount } from '../../../../api/access';

const { Option } = Select;

const EditAccessInfoModal = ({ visible, onClose, accessRecord, onSuccess, userID }) => {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (visible) {
      fetchGroups();
      if (accessRecord?.group?.id) {
        setSelectedGroupId(accessRecord.group.id);
      }
    }
  }, [visible, accessRecord]);

  const fetchGroups = async () => {
    setLoading(true);
    try {
      const response = await apiGroupsList();
      setGroups(response.results || []);
    } catch (error) {
      notification.error({
        message: 'Erro',
        description: 'Erro ao carregar os grupos disponíveis.',
        placement: 'topRight',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!selectedGroupId) {
      notification.warning({
        message: 'Atenção',
        description: 'Por favor, selecione um grupo.',
        placement: 'topRight',
      });
      return;
    }

    if (selectedGroupId === accessRecord?.group?.id) {
      notification.info({
        message: 'Informação',
        description: 'O grupo selecionado é o mesmo atual.',
        placement: 'topRight',
      });
      return;
    }

    setSubmitting(true);
    try {
      await apiUpdateAccessAccount(userID, accessRecord.id, selectedGroupId);
      notification.success({
        message: 'Sucesso',
        description: 'Perfil de acesso atualizado com sucesso.',
        placement: 'topRight',
      });
      onSuccess();
      handleClose();
    } catch (error) {
      notification.error({
        message: 'Erro',
        description: 'Erro ao atualizar o perfil de acesso.',
        placement: 'topRight',
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setSelectedGroupId(null);
    onClose();
  };

  return (
    <Modal
      title="Editar Perfil de Acesso"
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="cancel" onClick={handleClose}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={submitting}
          onClick={handleSubmit}
        >
          Confirmar
        </Button>,
      ]}
    >
      <div style={{ marginBottom: 16 }}>
        <p><strong>Vendedor:</strong> {accessRecord?.seller?.display_name || accessRecord?.account?.display_name}</p>
        <p><strong>Grupo Atual:</strong> {accessRecord?.group?.name}</p>
      </div>
      
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 8 }}>
          <strong>Novo Perfil de Acesso:</strong>
        </label>
        <Select
          style={{ width: '100%' }}
          placeholder="Selecione um grupo"
          value={selectedGroupId}
          onChange={setSelectedGroupId}
          loading={loading}
          notFoundContent={loading ? <Spin size="small" /> : 'Nenhum grupo encontrado'}
        >
          {groups.map(group => (
            <Option key={group.id} value={group.id}>
              {group.name}
            </Option>
          ))}
        </Select>
      </div>
    </Modal>
  );
};

export default EditAccessInfoModal;